<h2 mat-dialog-title>Select Patient</h2>
<mat-dialog-content>
    <div class="list-container">
        <mat-form-field appearance="outline" class="filter-field sticky">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="filterValue" (keyup)="applyFilter()" placeholder="Search patients">
            <mat-icon matSuffix *ngIf="!filterValue">search</mat-icon>
            <mat-icon matSuffix *ngIf="filterValue" (click)="clearFilters()" class="clickable">close</mat-icon>
            <!-- <mat-hint>Filter by name, surname, patient number, or diagnosis</mat-hint> -->
        </mat-form-field>
        <div class="scrollable-list">
            <mat-list *ngIf="filteredPatients && filteredPatients.length; else noResults">
                <mat-list-item *ngFor="let patient of filteredPatients" (click)="selectPatient(patient)"
                    class="auto-height">
                    <div class="list-item">
                        <div class="details">
                            <div matLine class="primary-text">
                                <b>{{ patient.surname }}, {{ patient.name }}</b>
                                <span class="primary-text-aside" *ngIf="patient.patientNumber"> ({{
                                    patient.patientNumber
                                    }})</span>
                            </div>
                        </div>
                        <div class="view-icon">
                            <mat-icon>visibility</mat-icon>
                        </div>
                    </div>
                </mat-list-item>
            </mat-list>
            <ng-template #noResults>
                <p class="grey-text">No results found.</p>
            </ng-template>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <!-- <button (click)="addEvent()" mat-raised-button color="primary">New Event</button> -->
    <button (click)="addPatient('invite')" mat-raised-button color="primary">New Patient</button>
</mat-dialog-actions>